"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContractOptions = void 0;
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const useSortedContracts_1 = require("@app/util/hooks/useSortedContracts");
const getContractOptions = (shift, employeeContracts, contractTypes, periodStart) => {
    const { contractId: forcedContractId, contractType: forcedContractType } = shift ?? {};
    const contractOnShift = (0, util_1.isValue)(forcedContractId)
        ? [
            {
                type: forcedContractType,
                id: forcedContractId,
            },
        ]
        : [];
    return new maybe_1.Maybe(employeeContracts)
        .map((_contracts) => (0, useSortedContracts_1.parseContracts)(_contracts, periodStart).activeContracts)
        .map((_contracts) => _contracts.some((c) => c.id === forcedContractId)
        ? _contracts
        : _contracts.filter((c) => c.id !== forcedContractId).concat(contractOnShift))
        .map((_contracts) => _contracts
        // attach name from contract type
        .map((c) => ({
        ...c,
        name: contractTypes.find((ct) => ct.id === c.type)?.name,
    }))
        .map((c) => ({
        value: c.id ?? '',
        label: `${c.name ?? c.type ?? '-'}${(0, util_1.isValue)(c.contractId) ? ` (${c.contractId})` : ''}`,
    })))
        .get(() => []);
};
exports.getContractOptions = getContractOptions;
